import React, { Component } from 'react';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import AppLoader from "../../app-components/app-loader.jsx";

const FIELD_MAP = [
  { key: 'about', oldKey: 'about', label: 'About' },
  { key: 'areaOfInterest', oldKey: 'areaOfInterest', label: 'Area of Interest' },
  { key: 'education', oldKey: 'education', label: 'Education' },
  { key: 'previousExperience', oldKey: 'previousExperience', label: 'Experience' },
  { key: 'twitterUrl', oldKey: 'twitterUrl', label: 'Twitter' },
  { key: 'linkedinUrl', oldKey: 'linkedinUrl', label: 'LinkedIn' },
];

/**
 * @param {string} dateStr - date string
 * @return {string} formatted IST date
 */
function formatToIST(dateStr) {
  if (!dateStr) return '';
  try {
    var d = new Date(dateStr);
    return d.toLocaleString('en-IN', {
      timeZone: 'Asia/Kolkata',
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    }) + ' IST';
  } catch (e) {
    return dateStr;
  }
}

const styles = {
  pageTitle: {
    fontSize: '20px',
    fontWeight: 600,
    color: '#2b2d42',
    marginBottom: '4px',
  },
  pageSubtitle: {
    fontSize: '13px',
    color: '#8d99ae',
    marginBottom: '20px',
  },
  profileCard: {
    marginBottom: '10px',
    border: '1px solid #e8ecf1',
    borderRadius: '6px',
    backgroundColor: '#fff',
    overflow: 'hidden',
  },
  collapsedRow: {
    display: 'flex',
    alignItems: 'center',
    padding: '14px 20px',
    cursor: 'pointer',
    userSelect: 'none',
    transition: 'background-color 0.15s',
  },
  chevron: {
    fontSize: '10px',
    color: '#8d99ae',
    marginRight: '12px',
    transition: 'transform 0.2s',
    display: 'inline-block',
    width: '12px',
  },
  authorName: {
    fontSize: '15px',
    fontWeight: 600,
    color: '#2b2d42',
  },
  authorEmail: {
    fontSize: '12px',
    color: '#8d99ae',
    marginBottom: '14px',
  },
  submittedAt: {
    fontSize: '11px',
    color: '#8d99ae',
    marginLeft: 'auto',
    flexShrink: 0,
    paddingLeft: '12px',
  },
  statusBadge: {
    fontSize: '10px',
    fontWeight: 700,
    color: '#fff',
    padding: '2px 8px',
    borderRadius: '3px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginLeft: '8px',
  },
  expandedBody: {
    padding: '0 20px 20px 20px',
    borderTop: '1px solid #e8ecf1',
  },
  fieldRow: {
    display: 'flex',
    marginBottom: '6px',
    fontSize: '13px',
    padding: '6px 8px',
    borderRadius: '4px',
  },
  fieldLabel: {
    fontWeight: 600,
    color: '#5d737e',
    minWidth: '130px',
    flexShrink: 0,
  },
  fieldValue: {
    color: '#2b2d42',
    wordBreak: 'break-word',
    flex: 1,
  },
  sectionLabel: {
    fontSize: '11px',
    fontWeight: 600,
    color: '#5d737e',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginTop: '14px',
    marginBottom: '8px',
    paddingBottom: '4px',
    borderBottom: '1px solid #e8ecf1',
  },
  buttonRow: {
    display: 'flex',
    gap: '10px',
    marginTop: '16px',
    paddingTop: '14px',
    borderTop: '1px solid #e8ecf1',
  },
  emptyState: {
    textAlign: 'center',
    padding: '40px 20px',
    color: '#8d99ae',
    fontSize: '14px',
  },
  btnApprove: {
    padding: '7px 20px',
    fontSize: '12px',
    fontWeight: 600,
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    backgroundColor: '#2b2d42',
    color: '#fff',
    letterSpacing: '0.3px',
  },
  btnReject: {
    padding: '7px 20px',
    fontSize: '12px',
    fontWeight: 600,
    border: '1px solid #ced3dc',
    borderRadius: '4px',
    cursor: 'pointer',
    backgroundColor: '#fff',
    color: '#2b2d42',
    letterSpacing: '0.3px',
  },
  btnConfirmReject: {
    padding: '7px 20px',
    fontSize: '12px',
    fontWeight: 600,
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    backgroundColor: '#c0392b',
    color: '#fff',
    letterSpacing: '0.3px',
  },
  btnCancel: {
    padding: '7px 20px',
    fontSize: '12px',
    fontWeight: 600,
    border: '1px solid #ced3dc',
    borderRadius: '4px',
    cursor: 'pointer',
    backgroundColor: '#fff',
    color: '#5d737e',
    letterSpacing: '0.3px',
  },
  changeBadge: {
    fontSize: '9px',
    fontWeight: 700,
    color: '#fff',
    backgroundColor: '#e67e22',
    padding: '1px 5px',
    borderRadius: '3px',
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
    marginLeft: '6px',
    verticalAlign: 'middle',
  },
};

class PendingAuthorProfiles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profiles: [],
      isLoading: true,
      actionInProgress: null,
      rejectingProfileId: null,
      feedbackText: '',
      expandedProfileId: null,
    };
  }

  componentDidMount() {
    this.loadProfiles();
  }

  loadProfiles = () => {
    this.setState({ isLoading: true });
    this.props.getPendingProfiles()
      .then((profiles) => {
        this.setState({ profiles: profiles || [], isLoading: false });
      })
      .catch(() => {
        this.setState({ isLoading: false });
      });
  }

  toggleExpand = (profileId) => {
    this.setState((prev) => ({
      expandedProfileId: prev.expandedProfileId === profileId ? null : profileId,
      rejectingProfileId: null,
      feedbackText: '',
    }));
  }

  handleApprove = (profileId) => {
    this.setState({ actionInProgress: profileId });
    this.props.onApprove(profileId)
      .then(() => {
        this.setState((prev) => ({
          profiles: prev.profiles.filter((p) => p.id !== profileId),
          actionInProgress: null,
          expandedProfileId: null,
        }));
        window.dispatchEvent(new Event('authorProfilesChanged'));
      })
      .catch(() => {
        this.setState({ actionInProgress: null });
      });
  }

  handleRejectClick = (profileId) => {
    this.setState({ rejectingProfileId: profileId, feedbackText: '' });
  }

  handleCancelReject = () => {
    this.setState({ rejectingProfileId: null, feedbackText: '' });
  }

  handleConfirmReject = (profileId) => {
    const { feedbackText } = this.state;
    this.setState({ actionInProgress: profileId });
    this.props.onReject(profileId, feedbackText || null)
      .then(() => {
        this.setState((prev) => ({
          profiles: prev.profiles.filter((p) => p.id !== profileId),
          actionInProgress: null,
          rejectingProfileId: null,
          feedbackText: '',
          expandedProfileId: null,
        }));
        window.dispatchEvent(new Event('authorProfilesChanged'));
      })
      .catch(() => {
        this.setState({ actionInProgress: null });
      });
  }

  renderProfile = (profile) => {
    const { actionInProgress, rejectingProfileId, feedbackText, expandedProfileId } = this.state;
    const pending = profile.pendingChanges || {};
    const isActing = actionInProgress === profile.id;
    const isRejecting = rejectingProfileId === profile.id;
    const isExpanded = expandedProfileId === profile.id;
    const statusColor = profile.status === 'draft' ? '#e67e22' : '#2980b9';
    const hasPreviousData = profile.status === 'pending' && (
      profile.about || profile.areaOfInterest || profile.education ||
      profile.previousExperience || profile.twitterUrl || profile.linkedinUrl
    );

    return (
      <div key={profile.id} style={styles.profileCard}>
        {/* Collapsed header row — always visible */}
        <div
          style={{
            ...styles.collapsedRow,
            backgroundColor: isExpanded ? '#f8f9fb' : '#fff',
          }}
          onClick={() => this.toggleExpand(profile.id)}
        >
          <span style={{
            ...styles.chevron,
            transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
          }}>
            ▶
          </span>
          <span style={styles.authorName}>
            {profile.authorName || 'Unknown Author'}
          </span>
          <span style={{ ...styles.statusBadge, backgroundColor: statusColor }}>
            {profile.status}
          </span>
          <span style={styles.submittedAt}>
            {formatToIST(profile.updatedAt || profile.createdAt)}
          </span>
        </div>

        {/* Expanded details */}
        {isExpanded && (
          <div style={styles.expandedBody}>
            <div style={styles.authorEmail}>{profile.authorEmail}</div>

            {/* Changes table — highlight diffs */}
            <div style={styles.sectionLabel}>
              {hasPreviousData ? 'Changes' : 'Submitted Profile'}
            </div>

            <div style={{ fontSize: '13px' }}>
              {FIELD_MAP.map((field) => {
                const newVal = pending[field.key] || null;
                const oldVal = profile[field.oldKey] || null;
                const isChanged = hasPreviousData && newVal !== oldVal;
                const isNew = !hasPreviousData && newVal;

                if (!newVal && !oldVal) return null;

                return (
                  <div key={field.key} style={{
                    ...styles.fieldRow,
                    backgroundColor: isChanged ? '#fff8e1' : (isNew ? '#f0faf4' : 'transparent'),
                    border: isChanged ? '1px solid #ffe08240' : 'none',
                  }}>
                    <div style={styles.fieldLabel}>
                      {field.label}
                      {isChanged && <span style={styles.changeBadge}>Changed</span>}
                      {isNew && <span style={{ ...styles.changeBadge, backgroundColor: '#27ae60' }}>New</span>}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={styles.fieldValue}>{newVal || '—'}</div>
                      {isChanged && oldVal && (
                        <div style={{
                          fontSize: '11px',
                          color: '#8d99ae',
                          marginTop: '3px',
                          textDecoration: 'line-through',
                        }}>
                          {oldVal}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Feedback textarea — shown when editor clicks Reject */}
            {isRejecting && (
              <div style={{
                marginTop: '12px',
                padding: '12px',
                backgroundColor: '#fdecea',
                borderRadius: '4px',
                border: '1px solid #e6474733',
              }}>
                <div style={{
                  fontSize: '11px',
                  fontWeight: 600,
                  color: '#c0392b',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  marginBottom: '6px',
                }}>
                  Feedback for Author (optional)
                </div>
                <textarea
                  value={feedbackText}
                  onChange={(e) => this.setState({ feedbackText: e.target.value })}
                  placeholder="Let the author know what needs to be changed..."
                  style={{
                    width: '100%',
                    padding: '8px 10px',
                    fontSize: '13px',
                    fontFamily: "'Source Sans Pro', sans-serif",
                    border: '1px solid #ced3dc',
                    borderRadius: '4px',
                    outline: 'none',
                    resize: 'vertical',
                    minHeight: '60px',
                    boxSizing: 'border-box',
                  }}
                />
                <div style={{ display: 'flex', gap: '8px', marginTop: '10px' }}>
                  <button
                    disabled={isActing}
                    onClick={() => this.handleConfirmReject(profile.id)}
                    style={{
                      ...styles.btnConfirmReject,
                      opacity: isActing ? 0.6 : 1,
                      cursor: isActing ? 'not-allowed' : 'pointer',
                    }}
                  >
                    {isActing ? 'Rejecting...' : 'Confirm Reject'}
                  </button>
                  <button
                    disabled={isActing}
                    onClick={this.handleCancelReject}
                    style={styles.btnCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}

            {!isRejecting && (
              <div style={styles.buttonRow}>
                <button
                  disabled={isActing}
                  onClick={() => this.handleApprove(profile.id)}
                  style={{
                    ...styles.btnApprove,
                    opacity: isActing ? 0.6 : 1,
                    cursor: isActing ? 'not-allowed' : 'pointer',
                  }}
                >
                  {isActing ? 'Processing...' : 'Approve'}
                </button>
                <button
                  disabled={isActing}
                  onClick={() => this.handleRejectClick(profile.id)}
                  style={styles.btnReject}
                >
                  Reject
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  render() {
    const { profiles, isLoading } = this.state;

    if (isLoading) {
      return <AppLoader message="Loading pending profiles..." />;
    }

    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={10} md={8} lg={7}>
          <div style={{ marginTop: '20px' }}>
            <div style={styles.pageTitle}>Author Profile Approvals</div>
            <div style={styles.pageSubtitle}>
              Review and approve or reject author profile submissions for this domain.
            </div>
          </div>

          {profiles.length === 0 ? (
            <Card>
              <CardBody>
                <div style={styles.emptyState}>
                  No pending author profiles to review.
                </div>
              </CardBody>
            </Card>
          ) : (
            profiles.map((p) => this.renderProfile(p))
          )}
        </GridItem>
      </GridContainer>
    );
  }
}

export default PendingAuthorProfiles;
